<template>
    <div
        class="component-container block w-1/2 h-auto cursor-pointer"
        @click="showOptions1 = !showOptions1"
    >
        <div
            class="component__select dropdown-select"
            :class="{ 'is-active': showOptions1 }"
        >
            <div class="component__select--name truncate">
                {{ model ? model.title : "Select a floor plan" }}
            </div>
        </div>

        <div class="component__select-wrapper" v-if="allModels && showOptions1">
            <ul class="component__select-options">
                <li
                    class="select--option"
                    v-for="(serie, serieLabel) in groupBy(allModels, 'series')"
                >
                    <span class="select--option-header">{{ serieLabel }}</span>
                    <ul>
                        <li
                            class="select--option-label"
                            v-for="carModel in serie"
                            :key="carModel.id"
                            :class="{
                                activeModel: model.title === carModel.title,
                            }"
                            @click="$emit('modelSelected', carModel)"
                        >
                            <input type="checkbox" :value="carModel" />
                            {{ carModel.title }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { watch, ref, onMounted } from "vue";

export default {
    props: {
        allModels: {
            required: true,
        },
        model: {
            required: true,
        },
    },
    setup() {
        const showOptions1 = ref(false);
        const overlay = ref(null);

        function groupBy(xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        }

        /* Methods to close the dropdowns if the dom is clicked */
        onMounted(() => {
            overlay.value = document.getElementById("overlay");
            overlay.value.addEventListener("click", (e) => {
                if (
                    showOptions1.value &&
                    !overlay.value.classList.contains("show") &&
                    overlay.value.classList.contains("show2")
                ) {
                    overlay.value.classList.add("show");
                    e.stopPropagation();
                } else if (
                    showOptions1.value &&
                    overlay.value.classList.contains("show") &&
                    overlay.value.classList.contains("show2")
                ) {
                    showOptions1.value = false;
                }
            });
        });

        watch(
            () => [showOptions1.value],
            (first, second) => {
                if (!showOptions1.value) {
                    overlay.value.classList.remove("show");
                    overlay.value.classList.remove("show2");
                } else {
                    overlay.value.classList.add("show2");
                }
            }
        );

        return { showOptions1, groupBy, overlay };
    },
};
</script>
